







































































































































































































































import mixin from './mixin'
import { Item } from '../../types/data-log'

import { SelectOption, Field } from './types'

export default mixin.extend({
  name: 'TableDatalogEditor',
  components: {},
  data() {
    return {
      dataLoggerItems: [] as Item[],
      newFieldItem: {} as Field,
    }
  },
  computed: {
    optsItem(): SelectOption[] {
      return this.dataLoggerItems.map((item: Item) => {
        return { value: item.tagUID, text: item.name }
      })
    },
  },

  methods: {
    addFieldItem() {
      this.model.attributes.fields.push(this.newFieldItem)
      this.newFieldItem = { tagUID: '', alias: '' }
    },
  },

  watch: {
    'model.attributes.dataLoggerId': async function(val: number) {
      this.model.attributes.dataLoggerId = val
      await this.findItem(val)
    },
  },

  async created() {
    if (this.model.attributes.dataLoggerId != -1) {
      await this.findItem(this.model.attributes.dataLoggerId)
    }
  },
})
